import { Button, message } from "antd";
import React from "react";
import { FaFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable"; // Import the autoTable plugin for tables
import header from "../../Assets/header.png";

export default function Pdf({ column, data, fileName, comment }) {
  const exportToPDF = () => {
    if (data.length > 0) {
      const doc = new jsPDF();

      // Load your images
      const headerImage = new Image();
      // const footerImage = new Image();
      headerImage.src = header; // Replace with your image path
      // footerImage.src = footer; // Replace with your image path

      // Define margins
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Add Header with Image
      const addHeader = () => {
        doc.addImage(headerImage, "PNG", 10, 10, 190, 200); // Adjust dimensions and position as needed
        doc.setLineWidth(0.5);
        doc.line(10, 40, pageWidth - 10, 40); // Horizontal line below the header
      };

      // Add Footer with Image
      const addFooter = () => {
        // doc.addImage(footerImage, "PNG", 10, pageHeight - 210, 190, 200); // Adjust dimensions and position as needed
        doc.setTextColor(150);
        doc.text(``, pageWidth - 20, pageHeight - 10); // Right-aligned page number
      };

      const addCustomDesignAfterTable = (startY) => {
        const maxWidth = pageWidth - 20;
        if (comment) {
          doc.text("Note : " + comment, 10, startY + 20, { maxWidth });
        }
        doc.setFontSize(8);
        const text1 = "Thank you for considering our products!";
        const textWidth1 = doc.getTextWidth(text1);
        const centerX1 = (pageWidth - textWidth1) / 2;
        doc.text(text1, centerX1, startY + 90);
      };

      // Add Header
      addHeader();

      // Extract headers and rows from the exportData
      const exportData = generateMappedArray(data, column);
      const headers = column.map((col) => col.title); // Headers from column array
      const rows = exportData.map(
        (item) =>
          column.map((col) =>
            col.key === "price"
              ? item["price"]
              : col.key === "updatedPrice"
              ? item["updatedPrice"]
              : item[col.key]
          ) // Map the data to the keys in the column array
      );

      // Generate table in the PDF
      doc.autoTable({
        head: [headers], // Column headers
        body: rows, // Table rows
        startY: 50, // Start table after header
        styles: { fontSize: 10 },
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        margin: { top: 50, bottom: 30 },
        didDrawPage: () => {
          // Add Footer on each page after the table is drawn
          addFooter();
          addHeader(); // Add header again if the table spans multiple pages
        },
      });

      const finalY = doc.lastAutoTable.finalY; // Get the final y position of the table
      addCustomDesignAfterTable(finalY);

      // Download the PDF
      doc.save("" + fileName + ".pdf");
    } else {
      message.error("No data for export");
    }
  };

  // Generate mapped array based on your columns
  const generateMappedArray = (data, column) => {
    return data.map((item) =>
      column.reduce((acc, col) => {
        acc[col.key] = item[col.key];
        return acc;
      }, {})
    );
  };
  return (
    <div>
      <Button
        icon={<FaFilePdf style={{ color: "red" }} />}
        className="orderFilter-print"
        style={{ borderRadius: "unset" }}
        onClick={exportToPDF}
      >
        PDF
      </Button>
    </div>
  );
}
